import React from 'react'
import styled from 'styled-components'
import { Link, Flex, Separator, Box } from '@sketch/components'
import { routes } from '@sketch/modules-common'
import {
  DocumentThumbnail,
  DocumentName,
} from '../../../workspace/pages/WorkspaceSettingsDocumentPreviews/DocumentPreviewsLayout.styles'
import { ReactComponent as Arrow } from '@sketch/icons/arrow-right-circle-semifilled-17'

const GoIcon = styled(Arrow)`
  width: 17px;
  height: 17px;
  flex: none;
  margin-left: 4px;
`

interface DocumentInfoHeaderProps {
  name: string
  thumbnail?: string
  identifier: string
}

export const DocumentInfoHeader = ({
  name,
  thumbnail,
  identifier,
}: DocumentInfoHeaderProps) => {
  const shareUrl = routes.SHARE_VIEW.create({ shareID: identifier })

  return (
    <>
      <Flex justifyContent="space-between">
        <Flex height={32} alignItems="center">
          <DocumentThumbnail src={thumbnail} alt={name} />
          <DocumentName>{name}</DocumentName>
        </Flex>
        <Link to={shareUrl} target="_blank">
          <Flex height={32} alignItems="center">
            View Document
            <GoIcon />
          </Flex>
        </Link>
      </Flex>
      <Box mt={6} mb={6}>
        <Separator />
      </Box>
    </>
  )
}
